import React, { useEffect, useState } from "react";
import axios from "axios";

import Loader from "../components/Loader";
import PageHeader from "../components/PageHeader";

import API_URL from "../../config";

const Profile = () => {

    const [loading, setLoading] = useState(true);

    const [saving, setSaving] = useState(false);

    const [changingPassword, setChangingPassword] = useState(false);

    const [profile, setProfile] = useState({

        fullName: "",

        email: "",

        phone: "",

        designation: "",

        profileImage: "",

        lastLogin: "",

        accountCreated: "",

        role: "Administrator"

    });

    const [passwordData, setPasswordData] = useState({

        currentPassword: "",

        newPassword: "",

        confirmPassword: ""

    });

    useEffect(() => {

        fetchProfile();

    }, []);

    const fetchProfile = async () => {

    try {

        setLoading(true);

        const token = localStorage.getItem("adminToken");

        const response = await axios.get(
            `${API_URL}/admin/profile`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );

        if (response.data.success) {

            setProfile({
                fullName: response.data.data.name,
                role: "Administrator",
                accountCreated: response.data.data.created_at
            });

        }

    } catch (error) {

        console.error(error);

    } finally {

        setLoading(false);

    }

};

    const handleProfileChange = (e) => {

        const {

            name,

            value

        } = e.target;

        setProfile((prev) => ({

            ...prev,

            [name]: value

        }));

    };

    const handlePasswordChange = (e) => {

        const {

            name,

            value

        } = e.target;

        setPasswordData((prev) => ({

            ...prev,

            [name]: value

        }));

    };

    const saveProfile = async () => {

    try {

        setSaving(true);

        const token = localStorage.getItem("adminToken");

        await axios.put(
            `${API_URL}/admin/profile`,
            {
                name: profile.fullName
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );

        alert("Profile Updated Successfully");

    } catch (error) {

        console.error(error);

        alert("Unable to update profile");

    } finally {

        setSaving(false);

    }

};

    const changePassword = async () => {

    if (passwordData.newPassword !== passwordData.confirmPassword) {

        alert("Passwords do not match.");

        return;

    }

    try {

        setChangingPassword(true);

        const token = localStorage.getItem("adminToken");

        await axios.put(

            `${API_URL}/admin/change-password`,

            {

                currentPassword: passwordData.currentPassword,

                newPassword: passwordData.newPassword

            },

            {

                headers: {

                    Authorization: `Bearer ${token}`

                }

            }

        );

        alert("Password Changed Successfully");

        setPasswordData({

            currentPassword: "",

            newPassword: "",

            confirmPassword: ""

        });

    } catch (error) {

        console.error(error);

        alert("Unable to change password.");

    } finally {

        setChangingPassword(false);

    }

};

    const resetProfile = () => {

        fetchProfile();

    };
        if (loading) {

        return (

            <Loader
                fullScreen={true}
                text="Loading Profile..."
            />

        );

    }

    return (

        <div className="space-y-6">

            <PageHeader

                title="My Profile"

                subtitle="Manage your administrator profile"

                showButton={false}

                breadcrumb={[
                    {
                        label: "Dashboard",
                        link: "/admin"
                    },
                    {
                        label: "Profile"
                    }
                ]}

            />

           <div className="bg-white rounded-3xl shadow-lg p-8">

<div className="grid grid-cols-1 lg:grid-cols-4 gap-8">

<div className="flex flex-col items-center">

<img
src={
profile.profileImage ||
"https://via.placeholder.com/180x180.png?text=Admin"
}
alt="Profile"
className="w-44 h-44 rounded-full object-cover border-4 border-gray-200 shadow"
/>

<button
className="mt-5 px-4 py-2 rounded-xl border border-teal-600 text-teal-600 hover:bg-teal-600 hover:text-white transition"
>
Change Photo
</button>

</div>

<div className="lg:col-span-3">

<h2 className="text-2xl font-semibold mb-6">
Personal Information
</h2>

<div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                            <div className="row">

                                <div className="col-md-6 mb-3">

                                    <label className="block text-sm font-medium text-gray-600 mb-2">

                                        Full Name

                                    </label>

                                    <input
                                        type="text"
                                        className="w-full rounded-xl border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500"
                                        name="fullName"
                                        value={profile.fullName}
                                        onChange={handleProfileChange}
                                    />

                                </div>

                                <div className="col-md-6 mb-3">

                                    <label className="block text-sm font-medium text-gray-600 mb-2">

                                        Email Address

                                    </label>

                                    <input
                                        type="email"
                                        className="w-full rounded-xl border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500"
                                        name="email"
                                        value={profile.email}
                                        onChange={handleProfileChange}
                                    />

                                </div>

                                <div className="col-md-6 mb-3">

                                    <label className="block text-sm font-medium text-gray-600 mb-2">

                                        Phone Number

                                    </label>

                                    <input
                                        type="text"
                                        className="w-full rounded-xl border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500"
                                        name="phone"
                                        value={profile.phone}
                                        onChange={handleProfileChange}
                                    />

                                </div>

                                <div className="col-md-6 mb-3">

                                    <label className="block text-sm font-medium text-gray-600 mb-2">

                                        Designation

                                    </label>

                                    <input
                                        type="text"
                                        className="w-full rounded-xl border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500"
                                        name="designation"
                                        value={profile.designation}
                                        onChange={handleProfileChange}
                                    />

                                </div>

                                <div className="col-md-6 mb-3">

                                    <label className="block text-sm font-medium text-gray-600 mb-2">

                                        Role

                                    </label>
                                <div>
                                    <input
                                        type="text"
                                        className="w-full rounded-xl border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500"
                                        value={profile.role}
                                        disabled
                                        readOnly
                                    />
                                </div>
                                </div>

                                <div className="col-md-6 mb-3">

                                    <label className="block text-sm font-medium text-gray-600 mb-2">

                                        Profile Image URL

                                    </label>

                                    <input
                                        type="text"
                                        className="w-full rounded-xl border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500"
                                        name="profileImage"
                                        value={profile.profileImage}
                                        onChange={handleProfileChange}
                                    />

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>
                        <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">

                <div className="col-lg-6 mb-4">

                    <div className="card shadow-sm h-100">

                        <div className="bg-white rounded-3xl shadow-lg p-6">

                            <h2 className="text-xl font-semibold mb-6">

                                Change Password

                            </h2>

                        </div>

                        <div className="card-body">

                            <div className="mb-3">

                                <label className="block text-sm font-medium text-gray-600 mb-2">

                                    Current Password

                                </label>

                                <input
                                    type="password"
                                    className="w-full rounded-xl border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500"
                                    name="currentPassword"
                                    value={passwordData.currentPassword}
                                    onChange={handlePasswordChange}
                                />

                            </div>

                            <div className="mb-3">

                                <label className="block text-sm font-medium text-gray-600 mb-2">

                                    New Password

                                </label>

                                <input
                                    type="password"
                                    className="w-full rounded-xl border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500"
                                    name="newPassword"
                                    value={passwordData.newPassword}
                                    onChange={handlePasswordChange}
                                />

                            </div>

                            <div className="mb-3">

                                <label className="block text-sm font-medium text-gray-600 mb-2">

                                    Confirm Password

                                </label>

                                <input
                                    type="password"
                                    className="w-full rounded-xl border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500"
                                    name="confirmPassword"
                                    value={passwordData.confirmPassword}
                                    onChange={handlePasswordChange}
                                />

                            </div>

                        </div>

                    </div>

                </div>

                <div className="bg-white rounded-3xl shadow-lg p-6">

<h2 className="text-xl font-semibold mb-6">
Account Information
</h2>

<div className="space-y-4">

<Detail label="Role" value={profile.role} />

<Detail label="Designation" value={profile.designation} />

<Detail label="Last Login" value={profile.lastLogin || "-"} />

<Detail label="Account Created" value={profile.accountCreated || "-"} />

<div>

<p className="text-sm text-gray-500">
Account Status
</p>

<span className="inline-block mt-1 px-3 py-1 rounded-full bg-green-100 text-green-700 text-sm font-medium">
Active
</span>

</div>

</div>

</div>

            </div>

               <div className="bg-white rounded-3xl shadow-lg p-8">

<h2 className="text-xl font-semibold mb-8">
Recent Activity
</h2>

<div className="grid grid-cols-2 lg:grid-cols-4 gap-6 text-center">

</div>

                <div className="card-body">

                    <div className="row text-center">

                       <div className="rounded-2xl bg-gray-50 p-6">

<h2 className="text-3xl font-bold text-teal-600">
125
</h2>

<p className="text-gray-500 mt-2">
Total Logins
</p>

</div>

                        <div className="col-md-3">

                            <h3 className="text-success">

                                18

                            </h3>

                            <p className="text-muted mb-0">

                                Profile Updates

                            </p>

                        </div>

                        <div className="col-md-3">

                            <h3 className="text-warning">

                                7

                            </h3>

                            <p className="text-muted mb-0">

                                Password Changes

                            </p>

                        </div>

                        <div className="col-md-3">

                            <h3 className="text-info">

                                2

                            </h3>

                            <p className="text-muted mb-0">

                                Active Sessions

                            </p>

                        </div>

                    </div>

                </div>

            </div>
                        <div className="bg-white rounded-3xl shadow-lg p-6">

               <div className="flex justify-end flex-wrap gap-4">

            <button
                onClick={resetProfile}
                disabled={saving || changingPassword}
                className="px-6 py-2 rounded-xl bg-gray-200 hover:bg-gray-300 disabled:opacity-60"
                >
                Reset
            </button>

                    <button
                onClick={changePassword}
                disabled={saving || changingPassword}
                className="px-6 py-2 rounded-xl bg-yellow-500 text-white hover:bg-yellow-600 disabled:opacity-60"
                >

                {changingPassword
                ? "Changing..."
                : "Change Password"}

                </button>

                   <button
            onClick={saveProfile}
            disabled={saving || changingPassword}
            className="px-6 py-2 rounded-xl bg-teal-600 text-white hover:bg-teal-700 disabled:opacity-60"
            >

            {saving
            ? "Saving..."
            : "Save Profile"}

            </button>

                </div>

            </div>

        </div>

    );

};
const Detail = ({ label, value }) => (
    <div>
        <p className="text-sm text-gray-500">
            {label}
        </p>
        <p className="font-semibold text-gray-800">
            {value}
        </p>
    </div>
);

export default Profile;